import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { appsAPI } from '../../api/client';
import { ThumbsUp } from 'lucide-react';

const UpvoteButton = ({ app, onUpvoteChange }) => {
  const { isAuthenticated, user, openAuthModal } = useAuth();
  const [upvoted, setUpvoted] = useState(app.user_upvoted);
  const [count, setCount] = useState(app.upvote_count);
  const [loading, setLoading] = useState(false);

  const handleUpvote = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (!isAuthenticated) {
      openAuthModal();
      return;
    }

    setLoading(true);
    try {
      const response = await appsAPI.upvote(app.id);
      const newUpvoted = response.data.upvoted;
      setUpvoted(newUpvoted);
      setCount((prev) => (newUpvoted ? prev + 1 : prev - 1));
      if (onUpvoteChange) {
        onUpvoteChange(newUpvoted);
      }
    } catch (error) {
      console.error('Failed to upvote:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleUpvote}
      disabled={loading}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border transition-all font-semibold text-xs ${
        upvoted
          ? 'bg-brand-yellow/20 border-brand-yellow text-brand-yellow'
          : 'bg-dark-bg border-dark-border text-gray-400 hover:border-brand-yellow/50 hover:text-brand-yellow'
      } ${loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      data-testid="upvote-button"
    >
      <ThumbsUp className={`w-4 h-4 ${upvoted ? 'fill-current' : ''}`} />
      <span className="font-semibold">{count}</span>
    </button>
  );
};

export default UpvoteButton;
